import moment, { Moment } from 'moment';

export default class DateHelper {
    public static daysAgo(date: Moment) {
        const now = moment();
        const days = now.diff(date, 'days');
        return days;
    }
}
